// extracted by mini-css-extract-plugin
var _1 = "card__IinL1";
var _2 = "contentWrapper__aha0f";
var _3 = "imageWrapper__c92Wj";
export { _1 as "card", _2 as "contentWrapper", _3 as "imageWrapper" }
export default { "card": _1, "contentWrapper": _2, "imageWrapper": _3 }
